import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/heating-btu-calculator',
  component: () => import('../../routes/HeatingBtuCalculator.svelte'),
  card: {
    id: 'heating-btu-calculator',
    title: 'Heating BTU Calculator',
    description:
      'Size any room or whole house: BTU/hr, MBH, and kW using climate-based baselines (25-55 BTU/sq ft) or detailed Manual-J-style conduction + infiltration heat loss.',
    icon: 'local_fire_department',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/heating-btu-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Heating BTU Calculator – Furnace & Boiler Sizing (BTU/hr, MBH)',
    description:
      'Free heating BTU calculator. Find the right furnace or boiler size in BTU/hr, MBH, or kilowatts for any room or whole house. Quick climate-based estimate or detailed Manual-J-style heat-loss calculation including walls, windows, doors, and infiltration.',
  },
};

export default meta;
